import React, { useState } from 'react';
import { Dropdown } from '../../../../../components/Dropdown';
import { IconSpan } from '../../../../../components/IconSpan';
import { JobHiringMemberRole } from '../../../../../entities/JobHiringMemberRole';
import { User } from '../../../../../entities/User';
import { buildSchedulingActionInfo } from '../../../../../utils/applicant_tracking/actions/schedulingActions';
import { PropTypes as ActionPropTypes } from '../../../../../components/Dropdown/DropdownMenu/DropdownAction';
import { ScheduleInterviewModal } from '../../../../../components/ApplicantTracking/ScheduleInterviewModal';
import { ApplicationActionInfo } from '../../../../../utils/applicant_tracking/actions/applicationActions';
import { PipelineApplication } from '../../../../../entities/applicant_tracking/PipelineApplication';

interface PropTypes {
  moveToStageActionInfo: ApplicationActionInfo;
  profileLink: string;
  moveCandidateToStage: () => void;
  application: PipelineApplication;
  currentUser: User;
  jobHiringMemberRole?: JobHiringMemberRole;
}

function viewCandidate(link: string) {
  return {
    action: () => (location.href = link),
    buttonChild: (
      <IconSpan
        spanText={'View Candidate'}
        icon={{ name: 'bi-eye', className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

function moveToStage(moveCandidateToStage: () => void) {
  return {
    action: moveCandidateToStage,
    buttonChild: (
      <IconSpan
        spanText={'Move to Stage'}
        icon={{ name: 'bi-arrow-return-right', className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

function scheduleInterview(
  setIsScheduleInterviewModalOpen: (isOpen: boolean) => void,
) {
  return {
    action: () => setIsScheduleInterviewModalOpen(true),
    buttonChild: (
      <IconSpan
        spanText={'Schedule Interview'}
        icon={{ name: 'bi-calendar4-week', className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

function viewCV(link: string) {
  return {
    action: () => window.open(link, '_blank'),
    buttonChild: (
      <IconSpan
        spanText={'View CV'}
        icon={{ name: 'bi-box-arrow-up-right', className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

function viewInterviews(profileLink: string) {
  return {
    action: () => (location.href = profileLink + '&tab=interviews'),
    buttonChild: (
      <IconSpan
        spanText={'View Interviews'}
        icon={{ name: 'bi-collection-play', className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

export function DropdownCandidate(props: PropTypes) {
  const menuActions: ActionPropTypes[] = [
    viewCandidate(props.profileLink),
    viewInterviews(props.profileLink),
  ];

  const [isScheduleInterviewModalOpen, setIsScheduleInterviewModalOpen] =
    useState(false);

  if (
    props.moveToStageActionInfo.allowed &&
    !props.moveToStageActionInfo.disabled
  ) {
    menuActions.push(moveToStage(props.moveCandidateToStage));
  }

  if (props.application.cvUrl) {
    menuActions.unshift(viewCV(props.application.cvUrl));
  }

  const schedulingPermission = buildSchedulingActionInfo(
    props.application,
    props.currentUser,
    props.jobHiringMemberRole,
  );

  if (schedulingPermission.allowed && !schedulingPermission.disabled) {
    menuActions.push(scheduleInterview(setIsScheduleInterviewModalOpen));
  }

  return (
    <>
      <Dropdown
        buttonIcon={{
          name: 'bi-three-dots',
          className: 'ms-2 fs-5 text-blue',
        }}
        menuActions={menuActions}
      />
      <ScheduleInterviewModal
        isOpen={isScheduleInterviewModalOpen}
        applicationId={props.application.id}
        interviewStageId={props.application.nextInterviewStageId}
        onClose={() => setIsScheduleInterviewModalOpen(false)}
      />
    </>
  );
}
